import commonStrings from "rivals/shared/strings/common";
import termsStrings from "rivals/shared/strings/terms";

export default {
  ...commonStrings,
  ...termsStrings,
  addBillingInfo: "Add Billing Info",
  changePaymentMethod: "Change Payment Method",
  creditCard: "Credit Card",
  creditCardNumber: "Credit Card Number",
  cvvHelp:
    "For Visa, MasterCard and Discover, the 3 digits on the back of your card.",
  cvvHelpAmex: "For American Express, the 4 digits on the front of your card.",
  editBillingInfo: "Edit Billing Info",
  expirationDate: "Expiration Date",
  expressCheckout: "Express Checkout",
  header: "Billing Info",
  newPaymentAgreement: "NEW PAYMENT SUBSCRIPTION AGREEMENT - Required",
  noBillingInformation: "No billing info",
  outstandingBalanceMsg: "Your account has an outstanding balance of",
  payPal: "PayPal",
  payPalAccount: "Paypal Account",
  paymentMethod: "Payment Method",
  postalCode: "Postal Code",
  unlinkPayment: "Adding a credit card will unlink your Paypal Account.",
  update: "Update",
  updateBillingTerms:
    "Thank you for adding a new payment method. By clicking the Update Payment Method button below, you authorize Oath Inc. to bill your new payment method for your designated subscription(s) plus any taxes, fees, or prorated amounts, until you cancel your subscription(s). You also agree that by updating the payment method may result in Oath Inc. collecting an outstanding balance for the service(s) connected to this card or checking account.",
  updatePaymentMethod: "Update Payment Method",
  usingDebit: "I am using a Debit Card"
};
